<template>
  <div class="job-page-main">
    <el-form ref="form" :model="searchForm" class="search-form" label-position="left">
      <el-row :gutter="20">
        <!--        <el-col :span="8">-->
        <!--          <el-form-item align="right" label="提交日期">-->
        <!--            <el-date-picker-->
        <!--              v-model="searchForm.rangeTime"-->
        <!--              type="daterange"-->
        <!--              range-separator="至"-->
        <!--              start-placeholder="开始日期"-->
        <!--              end-placeholder="结束日期"-->
        <!--            ></el-date-picker>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
        <el-col align="left" :span="5">
          <el-form-item label="作业ID" label-width="60px">
            <el-input v-model="searchForm.jobId" type="number" class="input-with-select">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="作业名称" label-width="70px">
            <el-input placeholder="搜索作业名称" v-model="searchForm.keyWords" class="input-with-select">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col align="right" :span="13">
          <el-button plaintext class="el-icon-search" @click="searchActualsJob">搜索</el-button>
          <el-button @click="GPUjumpFormSubmit">GPU表单提交作业</el-button>
          <el-button @click="jumpFormSubmit">表单提交作业</el-button>
          <el-button @click="vncJobSubmit">图形化作业</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs @tab-click="handleTabClick" v-model="activeIndex">
      <el-tab-pane label="运行作业" name="currentJob">
        <el-table :data="currentJobs.data" border style="width: 100%"
          :default-sort="{ prop: 'jobId', order: 'descending' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="center" label="作业ID" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.jobId }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="作业名称">
            <template slot-scope="scope">
              <router-link :to="{
      path: '/job-detail',
      query: { jobId: scope.row.jobId, flag: 0 },
    }" style="color: #409eff; text-decoration: none">{{ scope.row.name }}</router-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="用户">
            <template slot-scope="scope">
              <span>{{ scope.row.user }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="队列">
            <template slot-scope="scope">
              <span>{{ scope.row.partition }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="(核|卡)数" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.tresPerNode === null ? scope.row.cpus : scope.row.tresPerNode }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="节点数" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.nodes }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="节点">
            <template slot-scope="scope">
              <span>{{ scope.row.nodeList }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="提交时间" width="180" :formatter="formatSubmitTime">
          </el-table-column>
          <el-table-column align="center" label="开始时间" width="180" :formatter="formatStartTime">
          </el-table-column>
        </el-table>
        <el-pagination align="center" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentJobs.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="currentJobs.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="currentJobs.total">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="排队作业" name="penddingJob">
        <el-table :data="penddingJobs.data" v-loading.body="penddingJobs.listLoading" border style="width: 100%"
          :default-sort="{ prop: 'jobId', order: 'descending' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="center" label="作业ID" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.jobId }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="作业名称">
            <template slot-scope="scope">
              <router-link :to="{
      path: '/job-detail',
      query: { jobId: scope.row.jobId, flag: 0 },
    }" style="color: #409eff; text-decoration: none">{{ scope.row.name }}</router-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="用户">
            <template slot-scope="scope">
              <span>{{ scope.row.user }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="队列">
            <template slot-scope="scope">
              <span>{{ scope.row.partition }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="(核|卡)数" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.tresPerNode === null ? scope.row.cpus : scope.row.tresPerNode }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="节点数" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.nodes }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="节点">
            <template slot-scope="scope">
              <span>{{ scope.row.nodeList }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="提交时间" width="180" :formatter="formatSubmitTime">
          </el-table-column>
        </el-table>
        <el-pagination align="center" @size-change="handlePenddingSizeChange"
          @current-change="handlePenddingCurrentChange" :current-page="penddingJobs.currentPage"
          :page-sizes="[10, 20, 30, 40]" :page-size="penddingJobs.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="penddingJobs.total">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="挂起作业" name="suspendJob">
        <el-table :data="suspendJobs.data" border style="width: 100%"
          :default-sort="{ prop: 'jobId', order: 'descending' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column align="center" label="作业ID" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.jobId }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="作业名称">
            <template slot-scope="scope">
              <router-link :to="{
      path: '/job-detail',
      query: { jobId: scope.row.jobId, flag: 0 },
    }" style="color: #409eff; text-decoration: none">{{ scope.row.name }}</router-link>
            </template>
          </el-table-column>
          <el-table-column align="center" label="用户">
            <template slot-scope="scope">
              <span>{{ scope.row.user }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="队列">
            <template slot-scope="scope">
              <span>{{ scope.row.partition }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="(核|卡)数" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.tresPerNode === null ? scope.row.cpus : scope.row.tresPerNode }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="节点数" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.nodes }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="节点">
            <template slot-scope="scope">
              <span>{{ scope.row.nodeList }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="提交时间" width="180" :formatter="formatSubmitTime">
          </el-table-column>
          <el-table-column align="center" label="开始时间" width="180" :formatter="formatStartTime">
          </el-table-column>
        </el-table>
        <el-pagination align="center" @size-change="handleSuspendSizeChange"
          @current-change="handleSuspendCurrentChange" :current-page="suspendJobs.currentPage"
          :page-sizes="[10, 20, 30, 40]" :page-size="suspendJobs.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="suspendJobs.total">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Pagination from "@comm/components/Pagination.vue";
import ElSearchTablePagination from "@comm/components/pagination/search-table-pagination/src/main";
export default {
  name: "Job",
  components: {
    pagination: Pagination,
    elSearchTablePagination: ElSearchTablePagination,
  },
  data() {
    return {
      activeIndex: "currentJob",
      searchForm: {
        rangeTime: null,
        keyWords: null,
        startTime: undefined,
        endTime: undefined,
      },
      currentPage: 4,
      currentJobs: {
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 20,
      },
      suspendJobs: {
        listLoading: false,
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      penddingJobs: {
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      isTimes: null,
    };
  },
  methods: {
    open2(e) {
      clearTimeout(this.isTimes);

      this.isTimes = setTimeout(() => {
        console.log("开始请求数据");
        // let apiFn = null
        // clearTimeout(apiFn)
        // apiFn = setTimeout(() => {
        //   this.$notify({
        //     title: '成功',
        //     message: '客户端已连接成功',
        //     type: 'success',
        //     duration: 0
        //   });

        //   clearTimeout(apiFn)
        // }, 30000)

        this.http.get(`/client/sallocJob/selSvn/${e}`).then((res) => {
          console.log(res);
          this.$notify({
            title: "成功",
            message: "客户端已连接成功",
            type: "success",
            duration: 0,
          });
        });
        clearTimeout(this.isTimes);
      }, 0);
    },
    jumpFormSubmit() {
      this.$router.push("/form-submit");
    },
    GPUjumpFormSubmit() {
      this.$router.push("/form-submit-gpu");
    },
    vncJobSubmit() {
      this.$router.push("/vnc-submit");
    },
    formatSubmitTime(row) {
      var submitTime = row.submitTime;
      if (submitTime) {
        submitTime = submitTime.replace("T", " ");
        return submitTime;
      } else {
        return "-";
      }
    },
    formatStartTime(row) {
      var startTime = row.startTime;
      if (startTime && (row.state === "RUNNING" || row.state === "SUSPENDED")) {
        startTime = startTime.replace("T", " ");
        return startTime;
      } else {
        return "-";
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.currentJobs.pageSize = val;
      this.queryRunningJob();
    },
    handleCurrentChange(val) {
      this.currentJobs.currentPage = val;
      this.queryRunningJob();
    },
    handleTabClick(tab, event) {
      this.searchActualsJob();
    },
    handlePenddingSizeChange(val) {
      this.penddingJobs.pageSize = val;
      this.queryPenddingJob();
    },
    handlePenddingCurrentChange(val) {
      this.penddingJobs.currentPage = val;
      this.queryPenddingJob();
    },
    searchActualsJob() {
      const rangeTime = this.searchForm.rangeTime;
      if (rangeTime) {
        this.searchForm.startTime = rangeTime[0];
        this.searchForm.endTime = rangeTime[1];
      }
      if (this.activeIndex === "currentJob") {
        this.searchForm.state = "RUNNING";
        this.searchForm.st = "RUNNING";
        this.queryRunningJob();
      }
      if (this.activeIndex === "penddingJob") {
        this.searchForm.state = "PENDING";
        this.searchForm.st = "PENDING";
        this.queryPenddingJob();
      }
      if (this.activeIndex === "suspendJob") {
        this.searchForm.state = "SUSPENDED";
        this.searchForm.st = "SUSPENDED";
        this.querySuspendJob();
      }
    },
    queryRunningJob() {
      this.http
        .post(
          "/slurm/client/job/findMemoryPageJob?pageSize=" +
          this.currentJobs.pageSize +
          "&page=" +
          this.currentJobs.currentPage,
          this.searchForm,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // console.log(0);
          if (res && res.data.data.rows) {
            this.currentJobs.data = res.data.data.rows;
            this.currentJobs.total = res.data.data.total;
          } else {
            this.currentJobs.data = [];
          }
        });
    },
    queryPenddingJob() {
      this.http
        .post(
          "/slurm/client/job/findMemoryPageJob?pageSize=" +
          this.penddingJobs.pageSize +
          "&page=" +
          this.penddingJobs.currentPage,
          this.searchForm,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(1);
          if (res && res.data.data.rows) {
            this.penddingJobs.data = res.data.data.rows;
            this.penddingJobs.total = res.data.data.total;
          } else {
            this.penddingJobs.data = [];
          }
        })
        .finally(() => { });
    },
    handleSuspendSizeChange(val) {
      this.suspendJobs.pageSize = val;
      this.querySuspendJob();
    },
    handleSuspendCurrentChange(val) {
      this.suspendJobs.currentPage = val;
      this.querySuspendJob();
    },
    querySuspendJob() {
      this.http
        .post(
          "/slurm/client/job/findMemoryPageJob?pageSize=" +
          this.suspendJobs.pageSize +
          "&page=" +
          this.suspendJobs.currentPage,
          this.searchForm,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(2);
          if (res && res.data.data.rows) {
            this.suspendJobs.data = res.data.data.rows;
            this.suspendJobs.total = res.data.data.total;
          } else {
            this.suspendJobs.data = [];
          }
        });
    },
  },
  created() {
    this.searchActualsJob();
  },
  mounted() { },
};
</script>
<style lang="scss">
.job-page-header {
  position: relative;
}

.search-form {
  //position: absolute;
  right: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/workspace/components/Job.vue